const ChatSupport = {}

ChatSupport.install = function() {
  /**
   * How to insert new Zoho campaign?
   *  chatSupportScript.innerHTML is ONLY the contents of the <script></script> tag, nothing else
   *  IE: Remove the <script>...</script> tags
   */
  const body = document.querySelector('body')
  const chatSupportDiv = document.createElement('div')

  const chatSupportScript = document.createElement('script')
  chatSupportScript.type = 'text/javascript'
  chatSupportScript.innerHTML = `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "1b0e46be773569a37ea3a496cf59acbcd68d441ef41e058b5384fb2c1186da25", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.com/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);`

  body.appendChild(chatSupportDiv)
  body.appendChild(chatSupportScript)
}

export default ChatSupport
